let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1L8Re"), load("drB6v"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));